import React from 'react';
import { SearchOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Row, Col, Space } from 'antd';
import user from '../../../../assets/icons/user/01.svg';

import './styles.css';

export default function Header(props) {
    return (
        <Row wrap={true} className='mb-15'>
            <Col flex="auto">
                <div className='vertical-center'>
                    <Space wrap>
                        <img src={user} height={24} alt="img" className='align-middle' />
                        <span className='title-page'>Clientes</span>
                    </Space>
                </div>
            </Col>
            <Col flex="none">
                <Space wrap>
                    <Button
                        shape="round"
                        icon={<SearchOutlined />}
                        onClick={() => {}}
                    >
                        Buscar
                    </Button>
                    <Button
                        type='primary'
                        shape='round'
                        icon={<PlusOutlined />}
                        onClick={props.onNew}
                    >
                        Nuevo
                    </Button>
                </Space>
            </Col>
        </Row>
    );
}